import request from '../../axios';

export const getListBrandOwner = async (): Promise<IBrandResponse[]> => {
  const {data}: {data: IBrandResponse[]} = await request.get(
    '/api/v2/store/list-create/brand',
  );

  return data;
};
